<div>
    <vl-region v-if="viewModelLoading">
        <vl-layout>
            <div v-vl-align:center>
                <vl-loader message="De gegevens worden geladen. Even geduld, a.u.b."/>
            </div>
        </vl-layout>
    </vl-region>

    <vl-region v-else>
        <kl-organisation-payment-settings v-if="organisationInvoiceData" :organisation="organisation"
                                          :invoice-data="organisationInvoiceData"
                                          @update:change-invoice-type="changeInvoiceType"
                                          @update:refresh-organisation="refreshOrganisation"/>
        <vl-u-spacer mod-medium/>
        <kl-organisation-invoice-groups v-if="organisationInvoiceData?.paysByInvoice"
                                        :organisation="organisation" :invoice-data="organisationInvoiceData" :invoice-settings="organisationInvoiceSettings"/>
    </vl-region>
</div>
